(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sms-signup"] && !Shopify.designMode) return;
  try {
    const $ = (selector) => document.querySelector(selector);

   const setError = (errorMsg) => {
      if (errorMsg) {
         $("#sms-signup-form-display-error").style.display = "flex";
         $("#sms-signup-form-display-error").innerHTML = `${errorMsg}`;
      } else {
         $("#sms-signup-form-display-error").style.display = "none";
      }
   }

   const loadingState = (show) => {
      if (show) {
         $("#sms-signup-form-loading-state").style.display = "block";
      } else {
         $("#sms-signup-form-loading-state").style.display = "none";
      }
   }

   const isValidUkMobile = (phoneNumber) => {
      const cleaned = phoneNumber.replace(/[\s-]/g, '');
      return /^(?:\+44|0)7\d{9}$/.test(cleaned);
   }


   const signUpButton = $("button#sms-signup-form-submit-button");
   signUpButton.addEventListener("click", async () => {
      loadingState(true);
      setError();
      const phoneNumber = $("input#sms-signup-phone-number-input.sms-signup-phone-number-input");

      if (phoneNumber.value == "") {
         loadingState(false);
         setError("Please enter your phone number");
      } else if (!isValidUkMobile(phoneNumber.value)) {
         loadingState(false);
         setError("Please enter a valid UK phone number");
      } else {
         const response = await fetch("https://urbanaura-sms.vercel.app/api/sms/signup", {
            method: "POST",
            body: JSON.stringify({ phoneNumber: phoneNumber.value })
         });
         const result = await response.json();
         
         loadingState(false);
         if (result.success) {
            phoneNumber.value = "";
            $(".sms-signup-form#sms-signup-form").innerHTML = `
               <div style="width: 100%; color: white; text-align: center;">
                  You have joined the Urbanaura Insiders
               </div>
            `;
         } else {
            setError(result.error);
         }
      }

   });
  } catch(e) { console.error(e); }
})();

})();
